<div
  class="pr-4 pl-4 pt-4 pb-4 border highlight"
  (click)="clickCard()">
  <div>
    <div
      fxLayout="row"
      fxLayoutAlign="space-between start">
      <div>
        @if (card.layer) {
          <div
            fxLayout="row"
            fxLayoutAlign="start center"
            class="mt-1">
            @if (icon) {
              <img
                class="typeIcon mr-2"
                src="{{ icon }}" />
            }
            @if (!icon) {
              <div
                class="typeIcon mr-2"
                [style]="'background-color:' + (card.layer?.color || '#FFFFFF') + ';color:#FFFFFF;'"
                fxLayout="row"
                fxLayoutAlign="space-around center">
                @if (!card.layer?.isCustomIcon) {
                  <div
                    class="material-icons"
                    style="font-size: 16px">
                    {{ card.layer?.iconPath }}
                  </div>
                }
                @if (card.layer?.isCustomIcon) {
                  <img
                    [src]="card.layer?.iconPath | safeUrl"
                    class="customIcon" />
                }
              </div>
            }
            <div>
              @if (typeName) {
                <span
                  class="typeName">
                  {{ typeName }}
                </span>
              }
            </div>
          </div>
        }
      </div>
      @if (!!location) {
        <div
          class="ml-4 mb-2"
          >
          <div
            class="zoomToDocument"
            (click)="zoomToDocument()">
            <i
              class="icon icon-zoom-to_location"
            style="font-size: 1.5rem"></i>
          </div>
        </div>
      }
    </div>

    <div>
      <div
        fxLayout="row"
        fxLayoutAlign="start center"
        class="mt-1">
        <div
          fxLayout="column"
          fxLayoutAlign="start start">
          <div class="mt-1">
            <topo-avatar
              [size]="48"
              [name]="personName | stripHtml"
              [imageUrl]="imageUrl"
            [fontSize]="20"></topo-avatar>
          </div>
        </div>
        <div
          fxLayout="column"
          fxLayoutAlign="start start">
          <span class="summary">{{ assetName | stripHtml }}</span>
          @if (jobTitle) {
            <div
              class="job-title">
              {{ jobTitle | stripHtml }}
            </div>
          }
        </div>
      </div>

      <!-- Location row -->
      @if (location !== null) {
        <div
          fxLayout="row"
          [fxLayoutAlign]="address ? 'start start' : 'start center'"
          class="mt-4"
          >
          <div>
            @if (address) {
              <div
                class="address">
                {{ address[0] | stripHtml }}
                <br />
                {{ address[1] | stripHtml }}
              </div>
            }
          </div>
        </div>
      }

      <!-- Custom card row -->
      @if (customFieldsSet) {
        <div>
          <div class="mt-3">
            <div
              topoDynamicForm
              [formView]="truncatedView"
              [schema]="card?.dataset?.schema"
              [document]="card?.document"
              [isEdit]="false"
              [controlCollection]="documentControls"
              [dataset]="card?.dataset"
            [layerUId]="card?.layer?.uId ?? guidEmpty"></div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
